import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useAppDispatch } from "../../store";
import { clearUser } from "../../store/authSlice";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function Logout(): JSX.Element {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Clear user from Redux store
        dispatch(clearUser());

        // Clear local storage
        localStorage.clear();

        // Perform MSAL logout
        await instance.logoutPopup({
          postLogoutRedirectUri: "/",
        });

        // Redirect to home page
        window.location.href = "/";
      } catch (err) {
        console.error("Logout failed:", err);
        // Even if logout fails, redirect to login page
        window.location.href = "/";
      }
    };

    performLogout();
  }, [instance, dispatch]);

  return <LoadingSpinner fullscreen label="Logging out..." />;
}
